import React, { useCallback, useEffect } from 'react';
import MfaDialog from '@chegg/mfa-dialog';
import { useMediaQuery } from "../../common/hooks/mediaQuery.hook";
import { trigger } from "../../lib/clientCallback";
import { getOptimizelyClient } from "../../lib/optimizely/optimizley";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setLegacyMfa, setMfaError } from "../../store/reducer";
import { setLoading } from "../../store/sharedActions";
import { setMfa } from "../../store/sharedActions";
var Mfa = function Mfa() {
  var mfa = useAppSelector(function (state) {
    return state.mfa;
  });
  var backView = useAppSelector(function (state) {
    return state.backView;
  });
  var frontView = useAppSelector(function (state) {
    return state.frontView;
  });
  var showBack = useAppSelector(function (state) {
    return state.backView;
  });
  var countryCode = useAppSelector(function (state) {
    return state.country;
  });
  var dispatch = useAppDispatch();
  var onView = showBack && backView || frontView;
  var isMobile = useMediaQuery();
  var setIsPending = useCallback(function () {
    dispatch(setLoading({
      loading: true,
      onView: onView
    }));
  }, [onView, dispatch]);
  var mfaErrorCb = useCallback(function () {
    dispatch(setMfaError());
  }, [dispatch]);
  var mfaSuccessCb = useCallback(function (tokens) {
    dispatch(setMfa({
      showMfa: false
    }));
    dispatch(setLoading({
      loading: false,
      onView: onView
    }));
    trigger({
      type: 'auth',
      payload: {
        action: onView,
        status: 'success',
        data: tokens
      }
    });
  }, [dispatch, onView]);
  useEffect(function () {
    var client = getOptimizelyClient();
    client.onReady().then(function () {
      var variation = client.activate('_oneauth_mfa_by_app', mfa.mfaPayload.uuid, {
        FUNNEL_country: countryCode
      });
      if (variation === 'mfa_by_app' && !isMobile) {
        dispatch(setLegacyMfa(false));
      }
    });
  }, [dispatch, mfa, isMobile]);
  var hideMfa = useCallback(function () {
    dispatch(setMfa({
      showMfa: false
    }));
    dispatch(setLoading({
      loading: false,
      onView: onView
    }));
  }, [dispatch, onView]);
  if (!mfa.showMfa) {
    return null;
  }
  return /*#__PURE__*/React.createElement(MfaDialog, {
    authParams: {
      auth0Token: mfa.mfaPayload.mfa_token,
      cheggMfaToken: mfa.mfaPayload.cheggMfaToken,
      // TODO: rename when we have correct param name for new token
      uuid: mfa.mfaPayload.uuid,
      email: mfa.mfaPayload.email
    },
    onClose: hideMfa,
    onSuccess: mfaSuccessCb,
    onError: mfaErrorCb,
    onLoading: setIsPending,
    showMfaByApp: !mfa.legacy
  });
};
export default Mfa;